import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

type Props = {
  children: React.ReactNode;
  redirectLink?: string;
};

function ProtectedRouteCustomer({ children, redirectLink }: Props) {
  const customerToken = useSelector(
    (state: RootState) => state.customer.accessToken
  );
  const location = useLocation();

  const currentPath = encodeURIComponent(location.pathname + location.search);

  if (!customerToken) {
    return (
      <Navigate
        to={redirectLink ? redirectLink : `/customer/sendOtp?redirect=${currentPath}`}
        replace
      />
    );
  }

  return <>{children}</>;
}

export default ProtectedRouteCustomer;
